var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAdminMenuAvailable)?_c('a-layout',{staticClass:"wrap"},[_c('Sidebar'),_c('a-layout',[_c('a-layout-content',[_c('router-view',{on:{"updateAnalyticData":_vm.updateAnalyticData}})],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }